import React, { useEffect, useState, useRef } from 'react';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { useMediaQuery } from 'react-responsive';
import Grid from '@mui/material/Grid';
import LoupeItemHeaderComponent from './LoupeItemHeaderComponent';
import { LocalizationContext } from '../../App';


const LoupeLikertItemSelectionComponent = props => {

    const isMobileView = useMediaQuery({        
        query: '(max-width: 900px)'
      })

    const currentItem = props.currentItem;

    const [value, setValue] = React.useState(currentItem.selectedValue);

    const handleChange = (event) => {
        currentItem.selectedValue = event.target.value;
        currentItem.validator.touched();
        setValue(event.target.value);

        if(currentItem.validator.instantRevalidation) {
            currentItem.validator.revalidate();
        }
    };

    return (

        <LocalizationContext.Consumer>
            { ({strings}) => 

        <div>
            
            <LoupeItemHeaderComponent currentItem={currentItem} />


            { isMobileView == false ? 
            (
                <>
                <Grid container spacing={1}>

                    <Grid item md>
                   
                <FormControl component="fieldset">
                    <RadioGroup value={value} onChange={handleChange} row>

                        <Grid item >
                            {currentItem.minLabel}
                        </Grid>

                        <Grid item >
                            { currentItem.unitItems.map( (u, idx, arr) => {                                                                       
                                return(
                                    <FormControlLabel labelPlacement={'bottom'} label={u.label} value={u.value} key={u.value} control={<Radio />}/>
                                );
                            }) }
                        </Grid>

                        <Grid item>
                            {currentItem.maxLabel}
                        </Grid>

                        { currentItem.includeNa == "true" && 
                        <Grid item >
                            <FormControlLabel labelPlacement={ isMobileView == true ? 'end' : 'bottom' } label={ (currentItem.definedNa == "") ? strings.getString("texts.items.na") : currentItem.definedNa } value={"not-applicable"} key={"not-applicable"} control={<Radio />}/>
                        </Grid>
                        }
                        
                    </RadioGroup>
                </FormControl>
              

                        </Grid>

                    </Grid>     
               
                </>
            ) : (
                <>
                    <Grid container spacing={2}>
                        <Grid item xs/>

                        <Grid item xs={12}>
                            <FormControl component="fieldset">
                                <RadioGroup value={value} onChange={handleChange}>

                                { currentItem.unitItems.map( (u, idx, arr) => {
                                        
                                        var radioLabel = u.label;                                                                                                              
                                        // check for first element
                                        if( idx == 0 ) {
                                            radioLabel = <><span>{u.label}</span><span style={{marginLeft : '20px'}}>{currentItem.minLabel}</span></>;
                                        }

                                        // check for last element
                                        if( idx == (arr.length - 1)) {
                                            radioLabel = <><span>{u.label}</span><span style={{marginLeft : '20px'}}>{currentItem.maxLabel}</span></>;
                                        }
        
                                        return(
                                            <FormControlLabel labelPlacement={ isMobileView == true ? 'end' : 'bottom' } label={radioLabel} value={u.value} key={u.value} control={<Radio />}/>
                                        );

                                    }) }

                                { currentItem.includeNa == "true" && 
                                    <FormControlLabel labelPlacement={ isMobileView == true ? 'end' : 'bottom' } label={ (currentItem.definedNa == "") ? strings.getString("texts.items.na") : currentItem.definedNa } value={"not-applicable"} key={"not-applicable"} control={<Radio />}/>
                                }

                                </RadioGroup>
                            </FormControl>    
                        </Grid>

                        <Grid item xs/>
                    </Grid>
                </>
            )}

        </div>
        }
        </LocalizationContext.Consumer>
      );



}
export default LoupeLikertItemSelectionComponent;